import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/reminders`;

const model = abstractModel(resource);

model.getMessageDetail = async (params) => model.findById(params.id);

model.getCatalogs = async (params) => model.findById('catalogs');

model.getReminders = async (customerId) => {
  const newResource = `${resource}/customers/${customerId}/list`;
  return model.get({}, { path: newResource });
};

model.cancelReminder = async (reminderId) => {
  const newResource = `${resource}/${reminderId}/cancel`;
  return model.put({ }, { path: newResource });
};

export default model;
